<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="modal-header" id="modalTitle">
          <span class="material-icons" @click="close">
            keyboard_arrow_left
          </span>
          <button
            type="button"
            class="btn-close"
            @click="close"
            aria-label="Close modal"
          >
            Back
          </button>
        </header>
        <section class="modal-body" id="modalDescription">
          <swiper ref="modalSwiper" class="swiper" :options="swiperOptionVal">
            <swiper-slide
              v-for="(n, index) in getZoomerImages.LargeSize"
              :key="index"
            >
              <div class="swiper-zoom-container">
                <img
                  :src="
                    n.Url
                      ? n.Url
                      : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAAFElEQVR42mNkIBIwjiocVTiqEAQAJNYAFd868w4AAAAASUVORK5CYII='
                  "
                  :alt="n.Title"
                  v-if="!n.VideoUrl"
                />

                <img
                  :src="
                    n.Url
                      ? n.Url
                      : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAAFElEQVR42mNkIBIwjiocVTiqEAQAJNYAFd868w4AAAAASUVORK5CYII='
                  "
                  :alt="n.Title"
                  v-if="
                    n.VideoId &&
                      n.VideoType == 'cloudinary' &&
                      n.VideoId != currentVideoId
                  "
                  class="videoThumbnails"
                />
                <img
                  :src="
                    n.Url
                      ? n.Url
                      : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAAFElEQVR42mNkIBIwjiocVTiqEAQAJNYAFd868w4AAAAASUVORK5CYII='
                  "
                  :alt="n.Title"
                  v-if="
                    n.VideoId &&
                      n.VideoType == 'youtube' &&
                      n.VideoId != currentVideoId
                  "
                  class="videoThumbnails"
                />

                <!-- Vimeo Thumbnail Element -->
                <img
                  :src="
                    n.Url
                      ? n.Url
                      : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAAFElEQVR42mNkIBIwjiocVTiqEAQAJNYAFd868w4AAAAASUVORK5CYII='
                  "
                  :alt="n.Title"
                  v-if="
                    n.VideoId &&
                      n.VideoType == 'vimeo' &&
                      n.VideoId != currentVideoId
                  "
                  class="videoThumbnails"
                  :ref="n.videoId + 'thumbnail'"
                />

                <!-- Cloudinary video element -->
                <div
                  v-show="
                    n.VideoType == 'cloudinary' &&
                      n.VideoId == getCurrentVideoId
                  "
                  v-if="n.VideoType == 'cloudinary'"
                >
                  <cld-video
                    :id="n.VideoId"
                    cloudName="avd"
                    :publicId="n.PublicId"
                    :ref="n.VideoId"
                    tabindex="-1"
                    width="375"
                    controls
                    preload="metadata"
                    data-cld-colors='{ "base": "#0071ba", "accent": "#db8226", "text": "#fff" }'
                  >
                  </cld-video>
                </div>
                <div
                  v-show="
                    n.VideoType == 'youtube' && n.VideoId == getCurrentVideoId
                  "
                  v-if="n.VideoType == 'youtube'"
                >
                  <youtube
                    :video-id="n.VideoId"
                    :ref="n.VideoId"
                    controls="true"
                    :width="playerWidth"
                    :height="playerHeight"
                  ></youtube>
                </div>
                <vimeo-player
                  v-show="
                    n.VideoType == 'vimeo' && n.VideoId == getCurrentVideoId
                  "
                  v-if="n.VideoType == 'vimeo'"
                  :video-id="n.VideoId"
                  :data-vimeo-url="n.VideoUrl.Url"
                  :player-width="375"
                  :player-height="290"
                  :options="vimeoPlayerOptions"
                  controls="true"
                  :ref="n.VideoId"
                  autoplay="false"
                >
                </vimeo-player>
                <span
                  v-show="
                    (n.VideoId || n.version) && n.VideoId != getCurrentVideoId
                  "
                  @click="playVideo(n.VideoId, n.VideoType)"
                  class="playIcon"
                  :ref="n.VideoId + 'customPlay'"
                ></span>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </section>
        <footer class="modal-footer">
          <div class="double-tap-to-zoom">Pinch to Zoom</div>
        </footer>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "modal",
  props: {
    slideIndex: {
      type: Number,
      default: function() {
        return 0;
      }
    }
  },

  data() {
    return {
      swiperOptionVal: {
        zoom: true,
        slidesPerView: 1,
        initialSlide: this.slideIndex,
        centeredSlides: false,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          slideChange: () => {
            this.stopAllPlayingVideos();
          }
        }
      },
      currentVideoId: "",
      playerWidth: "",
      playerHeight: "",
      vimeoPlayerOptions: {
        playsinline: false
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    playVideo(videoId, videoType) {
      if (videoType === "youtube") {
        this.currentVideoId = videoId;
        this.$refs[videoId][0].player.playVideo();
      } else if (videoType === "vimeo") {
        this.currentVideoId = videoId;
        this.$refs[videoId][0].play();
      } else if (videoType === "cloudinary") {
        this.currentVideoId = videoId;
        var myVideo = document.getElementById(videoId);
        myVideo.play();
      }
    },
    stopAllPlayingVideos() {
      const frames = document.querySelectorAll("iframe");
      const videos = document.querySelectorAll("video");
      frames.forEach(i => {
        const src = i.getAttribute("src");
        i.setAttribute("src", "");
        i.setAttribute("src", src);
      });

      videos.forEach(v => {
        v.pause();
        v.currentTime = 0;
      });
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  mounted() {
    this.playerWidth = window.playerWidth - 30;
    this.playerHeight = this.playerHeight - 80;
  },
  computed: {
    ...mapGetters("product", ["getZoomerImages"]),
    player() {
      return this.$refs.youtube.player;
    },
    getCurrentVideoId() {
      return this.currentVideoId;
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    background-color: #fff;
  }
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
  height: 46px;
  align-items: center;
}

.modal-header {
  border-bottom: 2px solid rgb(229, 229, 229);
}

.modal-footer {
  justify-content: center;

  .double-tap-to-zoom {
    border-radius: 15px;
    background-color: #808080;
    color: #fff;
    font-size: 12px;
    font-family: $font-weight-normal;
    letter-spacing: 0.25px;
    min-width: 100px;
    padding: 5px 15px;
  }
}

.modal-body {
  position: relative;
  height: 75%;
}

.btn-close {
  border: none;
  cursor: pointer;
  background: transparent;
  color: rgb(60, 95, 104);
  font-size: 16px;
  font-family: $font-weight-normal;
  text-transform: uppercase;
  letter-spacing: 0.75px;
  line-height: 24px;
  height: 22px;
  padding-left: 0px;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  color: #666666;
  font-size: 20px;
}

.swiper-zoom-container {
  img {
    width: 100%;
  }
}

.playIcon {
  color: $aqua;
  transform: translate(-50%, -50%);
  font-size: 70px;
  position: absolute;
  left: 50%;
  top: 50%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='130' height='130' viewBox='0 0 130 130'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23000' fill-opacity='.5' d='M65,0 C29.12,0 0,29.12 0,65 C0,100.88 29.12,130 65,130 C100.88,130 130,100.88 130,65 C130,29.12 100.88,0 65,0 Z'/%3E%3Cpolygon fill='%23FFF' points='52 94.25 91 65 52 35.75'/%3E%3C/g%3E%3C/svg%3E%0A");
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
}

.videoThumbnails {
  width: 80% !important;
}
</style>
